// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationItem_link__JupCb","active":"NavigationItem_active__2chIu"};